var painters = {};
export function registerPainter(type, painter) {
    painters[type] = painter;
}
export function getPainter(type) {
    return painters[type];
}
